import React, { Component } from 'react';
import { Divider } from 'antd';
import { formatQuotaGroupData, formatQuotaFilterData, convertToListitem } from './utils'

class Targeting extends Component {

  constructor(){
    super()
    this.state = {
      quotaGroupData: [],
      quotaFilterData: []
    };
  }
  
  componentDidMount() {
    const { project, viewState } = this.props
    const lineItem = project.getLineItem()
    const country = lineItem[0].getCountryCode()
    const language = lineItem[0].getLanguageCode()
    const id = lineItem.length ? lineItem[0].getQuotaAttributesIds() : null

    if(viewState === "HISTORY_DID_LOAD" && id.length) {
      this.props.actions.getAttributesDetails(country, language, {id})
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { attributesDetails, project, viewState } = nextProps
    const lineItem = project.getLineItem()
    const quotaGroups = lineItem[0].getQuotaGroups()
    const quotaFilters = lineItem[0].getQuotaFilters()
    const country = lineItem[0].getCountryCode()
    const language = lineItem[0].getLanguageCode()
    const id = lineItem.length ? lineItem[0].getQuotaAttributesIds() : null

    if(viewState === "HISTORY_DID_LOAD" && id.length) {
      this.props.actions.getAttributesDetails(country, language, {id})
    }
    if(viewState === "ATTRIBUTES_DETAILS_DID_LOAD") {
      this.setState({
        quotaGroupData: quotaGroups && quotaGroups.length ? formatQuotaGroupData(quotaGroups, attributesDetails) : [],
        quotaFilterData: quotaFilters && quotaFilters.length ? formatQuotaFilterData(quotaFilters, attributesDetails) : []
      })
    }
  }

  renderQuotaFiltersTable() {
    const { quotaFilterData } = this.state
    if(!quotaFilterData || !quotaFilterData.length) return 'This project does not have any filters.'
    const list = convertToListitem(quotaFilterData, "quota")
    return (
      <div className="flex-list">
        {list}
      </div>
    )
  }

  renderQuotaGroupsTable() {
    const { quotaGroupData } = this.state
    if(!quotaGroupData || !quotaGroupData.length) return null
    const list = quotaGroupData.map((q,i) => 
      <div key={i}>
        <div className="quota-title"><b>Quota Group Name:</b> {q.name}</div>
        {convertToListitem(q.quotaList, "quota")}
      </div>
    )
    return (
      <div>
        {list}
      </div>
    )
  }

  render() {
    const { project } = this.props
    const lineItem = project.getLineItem()
    const quotaGroups = lineItem[0].getQuotaGroups()
    const quotaFilters = lineItem[0].getQuotaFilters()
    const quotaGroupsTable = quotaGroups ? this.renderQuotaGroupsTable() : null
    const quotaFiltersTable = quotaFilters ? this.renderQuotaFiltersTable() : 'This project does not have any filters.'
      return (
        <div className="panel">
          <h1>
            Targeting
          </h1>
          <div className="quota-title">
            <b>Filters</b>
          </div>
          {quotaFiltersTable}
          <Divider />
          {quotaGroupsTable}
        </div>
      );
  }
}

export default Targeting;